import { render, staticRenderFns } from "./NavDataDiffDisplayer.vue?vue&type=template&id=566dd0b8&"
import script from "./NavDataDiffDisplayer.vue?vue&type=script&lang=js&"
export * from "./NavDataDiffDisplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports